import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import dialogPlugin, { dialog } from 'BASE/plugins/dialogPlugin';
import router from 'TY/router';
import store from 'TY/store/store';
import ajaxSetting from 'BASE/components/ajaxSetting.component';
import App from 'TY/views/App.vue';
import dialogComponent from 'TY/views/Dialog.vue';
import VueClipboard from 'vue-clipboard2';
import Loading from 'vue-loading-overlay';
import loginPlugin from 'BASE/plugins/loginPlugin';
import logoComponent from 'TY/views/Logo.vue';
import LoadingComponent from 'TY/views/Loading.vue';
import 'vue2-datepicker/locale/zh-cn';  //統一變更時間選擇器語系
import VueCircleSlider from 'vue-circle-slider'
import numberPlugin from 'BASE/plugins/numberPlugin';
import datadogRumPlugin from 'BASE/plugins/datadogRumPlugin';
import UrlManager from 'BASE/common/UrlManager';
import 'BASE/filters/numberFilter'; // 增加number的Filter

Vue.use(UrlManager);
sync(store, router);
Vue.use(dialogPlugin, { dialogComponent });
Vue.use(loginPlugin, { router, dialog });

VueClipboard.config.autoSetContainer = true; //讓vue-clipboard2將container 設置為當前元素，避免在Bootstrap 模式不工作
Vue.use(VueClipboard);

Vue.use(require('vue-moment'));
Vue.use(numberPlugin);
Vue.use(VueCircleSlider);

Vue.component('custom-loader', LoadingComponent);
Vue.use(Loading, {
    loader: 'spinner',
    width: 64,
    height: 64,
    zIndex: 9999,
}, {
    default: (new Vue()).$createElement('custom-loader'),           
});

Vue.use(datadogRumPlugin, { isMobile: false });

Vue.component('logo', logoComponent);

new Vue({
    router,
    store,
    render: h => h(App),
    mixins: [ajaxSetting]
}).$mount('#app');
